import React, { FC, memo } from 'react'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Field, Formik } from 'formik'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Checkbox } from '@ucheba/ui/components/Checkbox/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Form } from '@ucheba/ui/components/Form/desktop'
import { IFormSelectEgeProps } from '../types'
import { useFormSelectEgeCore } from '../bll'

/** Форма выбора егэ */
const FormSelectEge: FC<IFormSelectEgeProps> = (props) => {
  const {
    buttonText = 'Выбрать предметы ЕГЭ',
    onSubmit,
    egeList,
    name,
    value = [],
  } = props

  const { initialValues, onSubmitForm, egeListPrepared } = useFormSelectEgeCore({
    egeList,
    value,
    name,
    onSubmit,
  })

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmitForm}>
      <Form fillByQuery>
        <Grid spacing={['large', 'xlarge']}>
          {egeListPrepared.map(({ id, name: egeName }) => (
            <GridCol uxs={8} key={id}>
              <Field
                type='checkbox'
                name={name}
                as={Checkbox}
                value={`${id}`}
                label={egeName}
                firstLetterUppercase
              />
            </GridCol>
          ))}
        </Grid>

        <Spacing spacing='xlarge' />

        <Button color='blue' type='submit'>
          {buttonText}
        </Button>
      </Form>
    </Formik>
  )
}

export { FormSelectEge }
export default memo(FormSelectEge)
